import rest from 'rest';
import mime from 'rest/interceptor/mime';
import errorCode from 'rest/interceptor/errorCode';
import template from 'rest/interceptor/template';
import TicketExpiredInterceptor from './interceptors/ticket_expired_interceptor';
import ValuesParserInterceptor from './interceptors/values_parser_interceptor';
import AccessInterceptor from './interceptors/access_interceptor';
import FormDataConverter from '../utils/form_data_converter';

const client = rest
	.wrap(template)
	.wrap(AccessInterceptor)
	.wrap(TicketExpiredInterceptor)
	.wrap(ValuesParserInterceptor)
	.wrap(errorCode);

export const performRequest = (options) => {
	return client.wrap(mime, options)(options);
};

export const load = (url, params={}, method="GET", mime="application/json;charset=UTF-8", options={}) => {
	return performRequest({ ...buildLoadRequestObject(url, params, method, mime), ...options });
};

export const get = (url, params={}) => {
	return load(url, params, "GET");
};

export const post = (url, params={}, options={}) => {
	if (options.multipart)
		return postMultipart(url, params, options);

	return load(url, params, "POST");
};

export const put = (url, params={}, options={}) => {
	return load(url, params, "PUT");
};

const postMultipart = (url, params={}, options={}) => {
	const multipartMimeType = "multipart/form-data";
	const formDataParams = params instanceof FormData ? params : FormDataConverter.convert(params);
	return load(url, formDataParams, "POST", multipartMimeType);
};

const buildLoadRequestObject = (url, params, method, mime) => {
	const contextPath = window.contextPath || '';
	const path = (!!url.match(/^https?:\/\//)) ? url : `${contextPath}${url}`;


	const request = { mime, path, method };
	const paramsKey = method == "GET" ? 'params' : 'entity';

	request[paramsKey] = params;

	return request;
};

export default {
	performRequest,
	load,
	get,
	post,
	put
};
